<template>
  <label class="custom-checkbox">
    <div @click="toggleCheck" class="checkbox">
      <img v-if="isChecked" class="checkmark" src="@/images/checkmark.svg" />
    </div>
    <slot></slot>
  </label>
</template>

<script>
export default {
  props: {
    value: Boolean,
  },
  data() {
    return {
      isChecked: this.value || false,
    };
  },
  methods: {
    toggleCheck() {
      this.isChecked = !this.isChecked;
      this.$emit("input", this.isChecked);
    },
  },
};
</script>

<style scoped>
.custom-checkbox {
  display: flex;
  flex-direction: row;
  align-items: center;
  column-gap: 11px;
}

.checkbox {
  height: 22px;
  width: 22px;
  min-width: 22px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  background: #ffffff14;
  border-radius: 8px;
  border: 1px solid #e0e2e5;
}

.checkmark {
  position: relative;
  height: 12px;
}
</style>
